"use client"

import { useEffect } from "react"

export function VidentRum() {
	useEffect(() => {
		const apiKey = process.env.NEXT_PUBLIC_VIDENT_API_KEY
		if (!apiKey) return

		import("vident-browser").then(({ createVidentBrowser }) => {
			createVidentBrowser({
				apiKey,
				appName: "vident",
				baseUrl: process.env.NEXT_PUBLIC_API_URL ?? "https://api.vident.dev",
				replay: {
					enabled: true,
					sampleRate: 0.1,
				},
			})
		})
	}, [])

	return null
}
